import { Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxTooltipDirective } from '../../../directives/onyx-tooltip.directive';
import { OverflowHelper } from '../../../helpers';

@Component({
  selector: 'onyx-data-preview-item',
  imports: [OnyxTooltipDirective, TranslatePipe],
  templateUrl: './onyx-data-preview-item.component.html',
  styleUrl: './onyx-data-preview-item.component.scss',
})
export class OnyxDataPreviewItemComponent {
  protected readonly overflowHelper = inject(OverflowHelper);

  public readonly label = input.required<string>();
  public readonly value = input<string>();
}
